<template>
  <div class="flex picker-container">
    <div>
      <v-menu
        v-model="menu"
        :nudge-right="10"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="300"
      >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field dense outlined class="calendar shrink  mr-3"
          id="fr_date" 
          ref="fr_date" 
          v-model="localFrDate"
          label="부터✽"
          readonly
          append-icon="mdi-calendar"
          v-bind="attrs"
          v-on="on"
        ></v-text-field>
      </template>
      <v-date-picker
        no-title 
        locale="ko-KR"
        v-model="localFrDate"
        @input="onFrDateChange"
      ></v-date-picker>
      </v-menu>
    </div>
   <v-menu
     v-model="menu2"
     :nudge-right="10"
     :close-on-content-click="false"
     transition="scale-transition"
     offset-y
     min-width="300"
   >
   <template v-slot:activator="{ on, attrs }">
     <v-text-field dense outlined class="calendar shrink rounded "
       id="to_date" 
       ref="to_date" 
       v-model="localToDate"
       label="까지✽"
       readonly
       append-icon="mdi-calendar"
       v-bind="attrs"
       v-on="on"
     ></v-text-field>
   </template>
   <v-date-picker
     no-title 
     locale="ko-KR"
     v-model="localToDate"
     @input="onToDateChange"
   ></v-date-picker>
   </v-menu>
 
   <button type="button" class="refresh_btn mt-2" @click="$emit('refresh')" v-show="$route.path !== '/record/market'">
     <v-icon color="white">
       mdi-magnify
     </v-icon>
   </button>
   </div>
 </template>
 
 <script>
 export default {
   name: 'DatePickerComponent',
   props: {
     fr_date: {
       type: String,
       default: ""
     },
     to_date: {
       type: String,
       default: ""
     },
   },
   data() {
     return {
       menu: false,
       menu2: false,
       localFrDate: this.fr_date,
       localToDate: this.to_date,
       
     }
   },
   watch: {
     fr_date(newVal) {
       this.localFrDate = newVal;
     },
     to_date(newVal) {
       this.localToDate = newVal;
     }
   },
   methods: {
     onFrDateChange(date) {
       this.localFrDate = date;
       this.$emit("update:fr_date", date);
       this.menu = false;
     },
     onToDateChange(date) {
       this.localToDate = date;
       this.$emit("update:to_date", date);
       this.menu2 = false;
     }
   }
 }
 </script>
 
 <style lang="scss" scoped>
.picker-container{
  margin-top:5px;
  margin-left:10px;
}
.calendar{
  min-width:160px !important;
  max-width:160px !important;
  border-radius: 50px !important;
  margin-right:5px !important; 

  .v-text-field__slot{
    margin-left:10px !important;
  }
  .v-input__slot{
    height:45px !important;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
  }
  .mdi-calendar{
    margin-top:5px;
    color:#a8a8a8;
  }
}
@media only screen and (max-width: 768px) {

.calendar {
  max-width:125px !important;
  margin-right: 1px !important;
}
}
 </style>
 